import React from "react";

export default function Tab() {
  return <div style={{height: '100vh', overflow: 'hidden'}}>
    <iframe title="Plotgate Webapp" src="https://www.plotgate.ch/de/" style={{width: '100%', height: '100%', border: 0}}></iframe>
  </div>;
}